<div class="dialog">
  <div class="dialog-background"></div>
  <div class="dialog-content">
    <div class="dialog-close">
      <app-ds-icon name="close-x" size="icon-size-3" color="var(--color-core-neutral-7)" (click)="dismissSurvey.emit(dialogType === 'survey')"></app-ds-icon>
    </div>
    @if (dialogType === 'survey') {
      <app-account-greenness-survey
        webApp="true"
        [appLocation]="appLocation"
        [showSurvey]="showSurvey"
        (surveySubmit)="onSurveySubmit($event)">
      </app-account-greenness-survey>
    } @else {
      <app-account-greenness-notification webApp="true" [success]="success" (closeNotification)="dismissSurvey.emit(false)">
      </app-account-greenness-notification>
    }

  </div>
</div>
